import type { MouseEvent } from "react";
import {
  Link,
  NavLink,
  type LinkProps,
  type NavLinkProps,
} from "react-router-dom";
import { useQuoteJourney } from "./quoteJourneyContext";
function useSettingsClick(to: string, onClick?: LinkProps["onClick"]) {
  const context = useQuoteJourney();
  return (event: MouseEvent<HTMLAnchorElement>) => {
    onClick?.(event);
    if (
      !context ||
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey ||
      event.currentTarget.target === "_blank"
    )
      return;
    event.preventDefault();
    void context.controller.openSettings(to);
  };
}
export function QuoteSettingsLink({
  to,
  onClick,
  ...rest
}: Omit<LinkProps, "to"> & { to: string }) {
  return <Link {...rest} to={to} onClick={useSettingsClick(to, onClick)} />;
}
export function QuoteSettingsNavLink({
  to,
  onClick,
  ...rest
}: Omit<NavLinkProps, "to"> & { to: string }) {
  return <NavLink {...rest} to={to} onClick={useSettingsClick(to, onClick)} />;
}
export function QuoteJourneyReturn({ className }: { className?: string }) {
  const context = useQuoteJourney();
  return (
    <Link
      className={className}
      aria-label={
        context?.controller.originHref ? "返回继续报价" : "返回快速报价"
      }
      to={context?.controller.originHref ?? "/app/quickquote"}
      onClick={(event) => {
        if (
          !context ||
          event.button !== 0 ||
          event.metaKey ||
          event.ctrlKey ||
          event.shiftKey ||
          event.altKey
        )
          return;
        event.preventDefault();
        void context.controller.returnToOrigin();
      }}
    >
      <span aria-hidden="true">← </span>
      {context?.controller.originHref ? "返回继续报价" : "返回快速报价"}
    </Link>
  );
}
